import { isNil } from 'lodash';
import React, { ReactNode } from 'react';
import { Easing } from 'react-native';
import { View } from '@shared/components/View';
import { MBAnimation } from '@shared/components/animation';
import { MBIconV2 } from '@shared/components/image';
import { Colors, grid } from '@shared/styles';

interface Props {
  children?: ReactNode;
  open?: boolean;
  style?: React.CSSProperties;
  onClick?: () => void;
  showDownArrow?: boolean;
}

export function DropdownButton({
  children,
  open = false,
  style = {},
  onClick,
  showDownArrow = true,
}: Props) {
  const arrowDirection = open ? 'up' : 'down';
  const disabled = isNil(onClick);

  return (
    <div
      onClick={onClick}
      onKeyPress={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick?.();
        }
      }}
      tabIndex={0}
      style={{
        flexDirection: 'row',
        backgroundColor: Colors.v2.white,
        border: `1px solid ${Colors.v2.gray10}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: grid(1.25),
        paddingRight: grid(1),
        borderRadius: 8,
        height: 40,
        cursor: disabled ? 'default' : 'pointer',
        pointerEvents: disabled ? 'none' : 'auto',
        ...style,
      }}
    >
      {children}
      {showDownArrow && (
        <View marginLeft={1}>
          <MBAnimation
            duration={200}
            easing={Easing.inOut(Easing.quad)}
            disabled={arrowDirection === 'down'}
            rotate={{ from: '0deg', to: '-180deg' }}
          >
            <MBIconV2 color={Colors.v2.purple} name="arrow-point-down-heavy" size={grid(1.25)} />
          </MBAnimation>
        </View>
      )}
    </div>
  );
}
